import Parse from 'parse'
import moment from 'moment-timezone'
import { param } from 'jquery'

moment.locale('es')
moment.tz.setDefault('America/Mexico_City')

class Players extends Parse.Object {
  
  constructor() {
    super('Player')
  }

  get createdAt () {
    return moment(this.get('createdAt')).format('dddd DD MMMM, YYYY')
  }

  get fullName(){
    return this.firstName + " " + this.lastName 
  }

  get firstName(){
    return this.get('firstName')
  }  
  
  get lastName(){
    return this.get('lastName')
  }

  get foot(){
    return this.get('foot')
  }

  get height(){
    return this.get('height')
  }  

  get positions(){
    return this.get('positions')
  }

  get passport(){
    return this.get('passport')
  }

  get ageSet(){
    return `'${moment(this.birthday).format('YY')} (${this.year})`
  }

  get year(){
    const m = moment(this.birthday, "DD.MM.YYYY");
    const years = moment().diff(m, 'years', false);
    return years
  }

  get age(){
    return moment(this.birthday, "MM/DD/YYYY").month(0).from(moment().month(0))
  }

  get birthday(){
    return this.get('birthday')
  }

  get league(){
    return this.get('league')
  }

  get avatar(){
    return this.get('avatar') ? this.get('avatar').url() : null
  }  
  
  get video(){
    return this.get('video') ? this.get('video') : null
  }
  
  get team(){
    return this.get('team')
  }

  get passportName(){
    return this.get('passport')
  }

  get nationality(){
    return this.get('nationality')
  }

  get skills(){
    return this.get('skills')
  }

  get email(){
    return this.get('email')
  }

  get willFit(){
    return this.get('willFit')
  }

  

   //--- Relations and pointers  
  loadWish() {
    return this.relation('wishLists').query().find()
  }

  loadPassport() {
    return this.relation('passport').query().find()
  }
  
  //-- Load Info
  static load () {
    return Parse.Cloud.run('playersList')
  }
  

  // --Filters
  static filter (params) {   
    return Parse.Cloud.run('playersFilter', params)
  }

  //-- Load User
  static loadInfoUnique(id){
    const query = new Parse.Query(this) 
    return query.get(id)
  }

  static savePlayer(params){
    
    console.log(params.id)
    if (params.id != ''){

      const user = Players.createWithoutData(params.id)
      user.set('firstName', params.name)
      user.set('lastName', params.lastname)
      user.set('team', params.team)
      user.set('league', params.league)
      user.set('email', params.email)
      user.set('willFit', params.skillGral)
      user.set('cost', params.cost)
      user.set('height', params.height)
      user.set('birthday', params.fecha)
      user.set('nationality', params.nacionalidad) 
      user.set('passport', params.pasaporte)
      user.set('foot', params.pierna)
      user.set('positions', params.position)
      user.set('skills', params.skills)
  
      return user.save()
    } else{

      const user = new Players() 

      user.set('firstName', params.name)
      user.set('lastName', params.lastname)
      user.set('team', params.team)
      user.set('league', params.league)
      user.set('email', params.email)
      user.set('willFit', params.skillGral)
      user.set('cost', params.cost)
      user.set('height', params.height)
      user.set('birthday', params.fecha)
      user.set('nationality', params.nacionalidad) 
      user.set('passport', params.pasaporte)
      user.set('foot', params.pierna)
      user.set('positions', params.position)
      user.set('skills', params.skills)
  
      return user.save()
    }

   

  }

  static async saveDetail(params){
  
    const user = Players.createWithoutData(params.player.id)

    const file = params.file
    const name = params.id
    
    const iconImageFile = new Parse.File(name, file)
    
    await iconImageFile.save()
    user.set('avatar', iconImageFile)
    user.set('video', params.video)

    return await user.save()
  }

  static saveList(param) {

    const params = {
      nameList: '',
      playerId: param.id
    }

    return Parse.Cloud.run('addPlayerToList', params)
  }

  static deleteList(param) {

    const params = {
      nameList: '',
      playerId: param.id
    }

    return Parse.Cloud.run('removePlayerList', params)
  }

  static removeUserList(params) {
    return Parse.Cloud.run('deletePlayer', params)
  }


  dump(){
    console.log(this)
  }

}

export default Players
